import { Button } from '@servicetitan/anvil2';
import { footer } from './SettingsFooter.module.css';

interface SettingsFooterProps {
    isDirty: boolean;
    isSaving: boolean;
    onCancel: () => void;
    onSave: () => void;
}

export const SettingsFooter = ({ isDirty, isSaving, onCancel, onSave }: SettingsFooterProps) => {
    return (
        <div className={footer}>
            <Button appearance="secondary" onClick={onCancel} disabled={!isDirty || isSaving}>
                Cancel
            </Button>
            <Button appearance="primary" onClick={onSave} disabled={!isDirty || isSaving}>
                Save
            </Button>
        </div>
    );
};
